module.exports = __webpack_public_path__ + "img/mission-image.ba8f62c4.png";